import React from 'react'
import Sidebar from '../Sidebar/Sidebar'
import { Outlet } from 'react-router-dom'
import Header from '../Header/Header'

const Main = () => {
  return (
    <div>
      <Header />
      <div id="layoutSidenav">
        <Sidebar />
        <Outlet />
      </div>
    </div>
  )
}

export default Main